module.exports = __webpack_public_path__ + "img/INSIGHTS (7).7cb7595b.png";